import * as React from "react";
import { Button, Tooltip } from "antd";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { useContext, useEffect, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import { BcheckTypeEnum } from "src/services/interfaces/UserInterface";
import IGenericButtons from "../Interfaces/IGenericButtons";

export default function ReloadComplianceButton(
  props: {
    changePhase: boolean;
    bcheckType: BcheckTypeEnum;
    disabledIcon?: string;
    approvedTooltipTitle?: string;
    isNotBlue?: boolean;
  } & IGenericButtons
) {
  const { tradeService } = useContext(ServiceContext);
  const [click, setClick] = useState(false);
  const [bCheck, setBCheck] = useState<string>("");

  let requestSent = true;

  useEffect(() => {
    const values: string = props.bcheckType;

    setBCheck(values);
  }, [props.bcheckType]);

  const { isUserComplianceApproved, isUserCreditApproved } = props.trade;

  const isSpouseComplianceApproved = props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse.isSpouseComplianceApproved : true;
  const isSpouseDilligenceApproved = props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse.isSpouseCreditApproved : true;
  const isLawyerComplianceApproved = props.trade.lawyer ? props.trade.lawyer.isLawyerComplianceApproved : true;

  const checkDisabled = disableCheck();
  const fnDisabled = props.disabled ? props.disabled(props.trade) : true;

  const enabledStyle: React.CSSProperties = { backgroundColor: "rgb(201, 225, 255)", color: "#151524" };
  const disabledStyle: React.CSSProperties = { backgroundColor: "#ccffd3", color: "#868686" };
  const clickDisableStyle: React.CSSProperties = { backgroundColor: "#f7f7f7", color: "#979797" };
  const enabledIcon = props.icon ? props.icon : "reload";
  const disabledIcon = props.disabledIcon ? props.disabledIcon : "check";

  function handleClick() {
    tradeService.updateReLoadBackGroundCheck({
      tradeId: props.trade.id,
      bcheckType: bCheck,
      changePhase: props.changePhase
    }).catch(e => {
      ShowNotification.Error("Erro ao enviar Bcheck.", "Por favor tente novamente mais tarde houve um erro ao enviar o BCheck.");
      requestSent = false;
    });

    setTimeout(() => {
      if (requestSent) {
        ShowNotification.Success("Sucesso", "Requisição enviada, estamos realizando a validação do usuário em breve estará disponível.");
      }
    }, 500);
  }

  function disableCheck() {
    let isDisabled = true;

    if (props.bcheckType === BcheckTypeEnum.Compliance) {
      isDisabled = isDisabled && isUserComplianceApproved && isSpouseComplianceApproved;
    }

    if (props.bcheckType === BcheckTypeEnum.Credit) {
      isDisabled = isDisabled && isUserCreditApproved && isSpouseDilligenceApproved;
    }

    if (props.bcheckType === BcheckTypeEnum.LawyerCompliance) {
      isDisabled = isDisabled && isLawyerComplianceApproved;
    }

    return isDisabled;
  }

  return (
    <Tooltip
      title={
        fnDisabled && !checkDisabled ? (props.tooltipTitle ? props.tooltipTitle : "Validar Usuário") : props.approvedTooltipTitle ? props.approvedTooltipTitle : "Usuário validado"
      }
    >
      <Button
        icon={fnDisabled ? (checkDisabled ? disabledIcon : enabledIcon) : disabledIcon}
        disabled={fnDisabled && !checkDisabled && !click ? checkDisabled : true}
        className={props.isNotBlue ? "archive btn no-color" : ""}
        onClick={() => {
          setClick(true);
          handleClick();
        }}
        style={click ? clickDisableStyle : fnDisabled ? (checkDisabled ? disabledStyle : enabledStyle) : disabledStyle}
      >
        {props.children}
      </Button>
    </Tooltip>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/GenericButtons/ReloadBackgroundCheck/ReloadBackgroundCheck.tsx